import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["display", "space"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';

// Temporary until we remove all old tokens. At that point, the `space`
// prop can simply use the `Space` type from foundations-theming
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSpacer = styled.div.withConfig({
  displayName: "Spacer__StyledSpacer",
  componentId: "sc-9mvxx6-0"
})(props => {
  const theme = props.theme;
  const {
    $space,
    display,
    $cssStyles
  } = props;
  return Object.assign({
    boxSizing: 'border-box',
    display,
    blockSize: display === 'block' ? theme.space[$space] : undefined,
    inlineSize: display === 'inline-block' ? theme.space[$space] : undefined
  }, $cssStyles);
});
export const Spacer = _ref => {
  let {
      display = 'block',
      space = '400'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const as = display === 'inline-block' ? 'span' : undefined;
  const {
    domProps,
    tokenProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledSpacer, Object.assign({
    as: as,
    display: display,
    $space: space
  }, domProps, {
    $cssStyles: cssStyles
  }));
};
Spacer.displayName = 'Spacer';